// Simple Stripe test utility
import { loadStripe } from '@stripe/stripe-js';

export const testStripeConnection = async () => {
  try {
    console.log('Testing Stripe connection...');
    
    // Use hardcoded key as fallback for testing
    const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_live_51RahzAFv51ffpAgBiPegJpwpC7OdslShSV2rWvyOgt0qfle4QV0BfP64nEOLxtkOiJhA3UHMx6BUMRVdmoyJSQrR009Ol5D8I3';
    console.log('Publishable key source:', process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ? 'Environment' : 'Hardcoded fallback');
    console.log('Key preview:', publishableKey.substring(0, 20) + '...');
    
    if (!publishableKey) {
      throw new Error('No Stripe publishable key available');
    }
    
    const stripe = await loadStripe(publishableKey);
    
    if (!stripe) {
      throw new Error('Failed to initialize Stripe');
    }
    
    console.log('✅ Stripe initialized successfully');
    return { success: true, stripe };
    
  } catch (error) {
    console.error('❌ Stripe initialization failed:', error);
    return { success: false, error: error.message };
  }
};

export default testStripeConnection; 